import axiosNewApi from "../config/axiosNewApi";

export const listBrands = async (searchTerm = "", signal) => {
  try{

    return await axiosNewApi.get(`mobile/brands/search/${searchTerm}`, {
      withCredentials: true,
      signal,
    });
  } catch (error) {
    console.error("Error fetching brands:", error.message);
    throw new Error("An error occurred while fetching brands.");
  }
};
